module.exports = __webpack_public_path__ + "img/game_main_pc_261_off.71f86138.png";